import { WsClient } from "./wsClient";

const ACK_TIMEOUT_MS = 5000;
const MAX_ATTEMPTS = 3;

interface ChatSendPayload {
  conversationId: string;
  body: string;
  replyToId?: string;
}

export const chatSocket = new WsClient();

export const sendOverChatSocket = (payload: ChatSendPayload) =>
  new Promise<{ messageId: string }>((resolve, reject) => {
    // The server uses tempId to recognise a resend, so every attempt for this message carries the same one.
    const tempId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    let attempts = 0;
    let timer: ReturnType<typeof setTimeout>;

    const finish = (settle: () => void) => {
      clearTimeout(timer);
      chatSocket.off("chat:ack", onAck);
      chatSocket.off("chat:error", onError);
      settle();
    };
    const onAck = (_event: string, data: unknown) => {
      const ack = data as { tempId: string; messageId: string };
      if (ack.tempId === tempId) finish(() => resolve({ messageId: ack.messageId }));
    };
    const onError = (_event: string, data: unknown) => {
      const error = data as { tempId: string; message: string };
      if (error.tempId === tempId) finish(() => reject({ message: error.message }));
    };
    const attempt = () => {
      if (attempts === MAX_ATTEMPTS) {
        return finish(() => reject({ message: "Message could not be sent. Check your connection and try again." }));
      }
      attempts += 1;
      chatSocket.send("chat:send", { ...payload, tempId });
      timer = setTimeout(attempt, ACK_TIMEOUT_MS);
    };

    chatSocket.on("chat:ack", onAck, false);
    chatSocket.on("chat:error", onError, false);
    attempt();
  });
